import script from "./PrescriptionDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PrescriptionDetails.vue?vue&type=script&setup=true&lang=js"

import "./PrescriptionDetails.vue?vue&type=style&index=0&id=4ce54e36&lang=css"
import "./PrescriptionDetails.vue?vue&type=style&index=1&id=4ce54e36&scoped=true&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ce54e36"]])

export default __exports__